const modules = import.meta.glob('./*/*.ts', { eager: true });

const messages: Record<string, Record<string, Record<string, unknown>>> = {};

Object.keys(modules).forEach((path) => {
  const match = path.match(/\.\/([^/]+)\/([^/]+)\.ts$/);
  if (!match) return;

  const [, lang, namespace] = match;
  const module = modules[path] as Record<string, unknown>;

  if (!messages[lang]) {
    messages[lang] = {};
  }

  // 读取命名导出（如 export const home = {...}）
  const exported = module[namespace];
  if (exported && typeof exported === 'object') {
    messages[lang][namespace] = exported as Record<string, unknown>;
  }
});

export default messages;